import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import Api from 'services/Api'
import BaseModal from 'components/Modals/BaseModal'
import { Button } from 'components/Forms'
import { Card, Spinner } from 'ui'
import { closeModal } from 'store/actions/modals'
import { PermissionsItem } from 'components/Items'

const UserComputedPermissions = ({ userId }) => {
  const dispatch = useDispatch()
  const [computedPermissions, setComputedPermissions] = useState()
  const [permissionInfo, setPermissionInfo] = useState()

  useEffect(() => {
    async function fetchComputedPermissions() {
      const { result, success } = await Api(`/permissions/computed/${userId}`)
      if (!success) return
      setComputedPermissions(result)
    }
    fetchComputedPermissions()
  }, [userId])

  useEffect(() => {
    async function loadPermissionInfo() {
      const { permissionsInfo, success } = await Api('/permissions/permissions?returnPermissionsInfo=true')
      if (success) setPermissionInfo(permissionsInfo.permissionGroups)
    }

    loadPermissionInfo()
  }, [])

  return (
    <BaseModal hideButtons title="manager.users.seeComputedPermisionsModal">
      {!computedPermissions || !permissionInfo ? (
        <Card className="bg-light pt-3">
          <div className="text-center">
            <Spinner size="lg" />
          </div>
        </Card>
      ) : (
        <div className="accordion pb-3" id="permissionsCheck">
          {Object.keys(permissionInfo).map(key => (
            <PermissionsItem key={key} name={key} content={permissionInfo[key]} values={{ permissions: computedPermissions }} />
          ))}
        </div>
      )}

      <div className="mt-3">
        <Button text="actions.CLOSE" className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} />
      </div>
    </BaseModal>
  )
}

export default UserComputedPermissions
